import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDesign } from "../../context/contextDesign";
import { useThemeMode } from "../../context/contextTheme";
import sidebarMap from "../../config/menuMapping";
import "../styles/cloud.css";

const AzureDashboardLegacy = () => {
  const { theme } = useThemeMode();
  const { bHeightVal } = useDesign();
  const location = useLocation();

  const azureTabs = sidebarMap[3]?.subMenu?.[1]?.tabs
    ? Object.values(sidebarMap[3].subMenu[1].tabs)
    : [];

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const match = azureTabs.findIndex((tab) => location.pathname === tab.path);
    if (match !== -1) setActiveTab(match);
    // azureTabs is derived from the static sidebar configuration.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const ActiveComponent = azureTabs[activeTab]?.component;

  return (
    <div
      className="d-flex flex-column overflow-y-auto"
      style={{ height: bHeightVal }}
    >
      <div className="d-flex flex-row gap-2 mb-3 py-2 px-0">
        {azureTabs.map((tab, index) => (
          <Link
            key={tab.id}
            onClick={() => setActiveTab(index)}
            className="text-decoration-none"
          >
            <button
              style={{
                color:
                  activeTab === index ? theme.textColorInv : theme.textColor,
                background:
                  activeTab === index ? theme.textColor : theme.background2,
                width: 230,
                height: 43,
                borderRadius: 10,
                cursor: "pointer",
                border: `1px solid ${
                  activeTab === index ? theme.border : theme.border2
                }`,
                transition: "all 0.3s ease",
              }}
            >
              {tab.title}
            </button>
          </Link>
        ))}
      </div>

      {ActiveComponent && <ActiveComponent />}
    </div>
  );
};

export default AzureDashboardLegacy;
